// @vendors
import React, { useMemo } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

// @components
import { CommittedCapacityComplete, LightCommittedCapacity } from './components';
import { CommittedCapacityContextProvider } from './context/committed-capacity.context';
import PrebookingValidations from './components/PrebookingValidations/PrebookingValidations';


function CommittedCapacityContainer() {
  const flags = useFlags()

  const component = useMemo(() => {
    return flags.FEATURE_BOOK_WITH_CC
      ? <LightCommittedCapacity />
      : <CommittedCapacityComplete />;
  }, [flags.FEATURE_BOOK_WITH_CC]);

  return (
    <CommittedCapacityContextProvider>
      <PrebookingValidations>
        {component}
      </PrebookingValidations>
    </CommittedCapacityContextProvider>
  );
}

export default CommittedCapacityContainer;
